$w.onReady(function () {
//	if ($w('#upgradeDescriptionText') === null) $w('#upgradeBox').hide();
    
});


export function upgradeTitleButton_click(event) {
    let $item = $w.at(event.context);
    $item('#upgradeDescriptionContainer').expand();
    $item('#packageDescriptionContainer').collapse();
    $item('#selectedIndPackageContent').hide();
    $item('#selectedIndPackageUpgrade').show();
}

export function packageContentTitleButton_click(event) {
    let $item = $w.at(event.context);
    $item('#upgradeDescriptionContainer').collapse();
    $item('#packageDescriptionContainer').expand();
    $item('#selectedIndPackageUpgrade').hide();
    $item('#selectedIndPackageContent').show();
}